var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popover',{attrs:{"name":_vm.name,"pointer":_vm.pointer,"width":_vm.width,"event":_vm.event},on:{"show":function($event){_vm.value = $event.value}}},[_vm._v(" "+_vm._s(_vm.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }